import React, { useContext } from "react";
import { styled } from "@mui/material/styles";
import { AccountContext } from "../../store/AccountContext";
import { Navigate, useLocation } from "react-router-dom";
import SignUpForm from "../Onboarding/SignUp/SignUpForm";
import { APPLICATION_SOURCE } from "@booyaltd/core";
import {
  MEMBER_STATUS_STANDARD,
  MEMBER_STATUS_TRIAL,
} from "../../api/entities/UserProfile";
import { Element } from "react-scroll";

/**
 * PM5 T2 (money path, batch "freetrial-buynow") — converted from MUI v4 +
 * `makeStyles` to MUI v5+ `styled`.
 * See docs/epics/pm5-mui-v5-migration.md §3 (T2) and docs/mui-conversion-guide.md.
 *
 * **SUBSCRIPTIONS SURFACE.** Hosts the trial signup form (`SignUpForm`,
 * converted in T2/onboarding) and the logged-in redirect guard. The conversion
 * touches the wrapper `<div>`'s styling only — the `loggedIn`/`memberStatus`
 * condition, the `<Navigate>` and every `SignUpForm` prop are byte-identical.
 */

// was: useStyles().background — a bare <div>, which has no `sx` prop.
const Background = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.ffNavyLighter,
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  width: "auto",
  display: "flex",
  height: "80vh",
  marginBottom: theme.spacing(4),
  [theme.breakpoints.up("sm")]: {
    height: "auto",
  },
  "@media (min-width:769px)": {
    height: "auto",
  },
  [theme.breakpoints.up("md")]: {
    height: "auto",
  },
}));

const Stepper = () => {
  const location = useLocation();
  const { loggedIn, userProfile } = useContext(AccountContext);

  return (
    <>
      <Element name="onboarding-form">
        <Background>
          {loggedIn &&
          (userProfile?.memberStatus === MEMBER_STATUS_STANDARD ||
            userProfile?.memberStatus === MEMBER_STATUS_TRIAL) ? (
            <Navigate to="/videos" replace />
          ) : null}

          <SignUpForm
            source={APPLICATION_SOURCE.PUBLIC}
            page={location.pathname}
            title="Take Free Trial"
            background={false}
            route="try"
          />
        </Background>
      </Element>
    </>
  );
};

export default Stepper;
